import React from 'react';
import Nav from '../Components/Nav/Nav'
import Footer from '../Components/Footer/Footer';
import Team from '../Components/Team/Team';

const TeamPage = () => {
    return (
        <div className="App">
            <Nav />
            <Team />
            <Footer />
        </div>
    )
}

export default TeamPage;